export enum ViewSummaryBlock {
  Root = 'ViewSummary',
}

export enum ViewSummaryElement {
  Row = 'row',
}
